import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'

// 统一用 Fan，不再出现 Zee
import { Fan } from '../fan'
// const Fan = Fan

/**
 * 模板加载
 */
const _import = require('./_import')
import Layout from '../pages/layout'
import Block from '../pages/block'

/**
 * 基础路由
 */
const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    // 根路由删除，让动态路由接管
    // { path: '/', redirect: '/index', hidden: true },

    { path: '/login', component: () => import('../pages/login') },
    { path: '/jsc', component: () => import('../pages/jsc') },
    { path: '/bim', redirect: '/twin' },
    {
      path: '/twin',
      component: () => import('../pages/twin')
    },
    {
      path: '/help',
      component: Layout,
      children: [
        { path: '',meta:{hideSidebar: true}, component: () => import('../pages/help') }
      ]
    },
    {
      path: '/test-svg',
      component: () => import('../../pages/test-svg')
    },
    {
      path: '/svg-gallery',
      component: () => import('../../pages/svg-gallery')
    },
    {
      path: '/arco-icon-gallery',
      component: () => import('../../pages/arco-icon-gallery')
    },
    {
      path: '/error',
      redirect: '/error/403',
      component: Layout,
      children: [
        { path: '/error/403',meta:{hideSidebar: true}, component: () => import('../pages/error403') },
        { path: '/error/404',meta:{hideSidebar: true}, component: () => import('../pages/error404') },
        { path: '/error/500',meta:{hideSidebar: true}, component: () => import('../pages/error500') },
      ]
    },
  ]
})

export default router

import zongbu from './menus/zongbu'
import ganli from './menus/ganli'

const menus = { zongbu, ganli }

/**
 * 路由守卫
 */
let routerFresh = true
const whiteList = ['/login', '/install']
router.beforeEach(async (to, from, next) => {
  // 白名单
  if (whiteList.includes(to.path)) {
    if (localStorage.token || sessionStorage.token) {
      next('/')
    } else {
      next()
    }
    return
  }

  // 未登录
  const hasToken = localStorage.token || sessionStorage.token
  if (!hasToken) {
    Fan.message.warning('请登录')
    next('/login')
    return
  }

  // 登录超时
  if (localStorage.getItem('token-session')) {
    const session = +localStorage.getItem('token-session')
    const now = Date.now()
    if ((now - session) / 1000 >= 15 * 60) {
      Fan.message.error('登录超时，请重新登录')
      localStorage.clear()
      next('/login')
      return
    } else {
      localStorage.setItem('token-session', now)
    }
  }

  // 核心：动态路由只加载一次
  if (routerFresh) {
    try {
      routerFresh = false
      const { asyncRouter } = await getAsyncRouter()

      if (asyncRouter.length) {
        asyncRouter.forEach(route => {
          router.addRoute(route)
        })
        next({ ...to, replace: true })
      } else {
        next('/login')
      }
    } catch (err) {
      routerFresh = true
      next('/login')
    }
  } else {
    next()
  }
})

/**
 * 报错拦截
 */
router.onError((e) => {
  if (Fan.isDev) {
    console.log(e)
  }
  router.replace({ path: '/error/403' })
})

function findFirstMenu() {
  for (const role in menus) {
    const menuList = menus[role]
    for (const menu of menuList) {
      if (!menu.children && menu.path && menu.template) {
        return `/${menu.path}`
      }
    }
    for (const menu of menuList) {
      if (menu.children && menu.children.length > 0) {
        for (const child of menu.children) {
          if (child.path && child.template) {
            return `/${menu.path}/${child.path}`
          }
        }
      }
    }
  }
  return null
}

/**
 * 动态路由
 */
async function getAsyncRouter() {
  try {
    const response = await Fan.api.get('login')
    const { data } = response
    let asyncRouter = []
    let firstMenuPath = null

    if (data.data && data.data.user && data.data.user.auth_user && data.data.user.auth_user.systemname && menus[data.data.user.auth_user.systemname]) {
      Fan.store.state.user = data.data.user.auth_user
      Fan.store.state.user.avatar = Fan.store.state.user.avatar || require('@/assets/image/avatar.jpg')
      Fan.store.state.user.nickname = Fan.store.state.user.nickname || '默认昵称'
      Fan.store.state.user.entity = data.data.user.entity

      if (data.data.global_cache) {
        sessionStorage.setItem('fan-global_cache', JSON.stringify(data.data.global_cache))
      }

      localStorage.setItem('user-role', data.data.user.auth_user.systemname)

      if (menus[data.data.user.auth_user.systemname] && menus[data.data.user.auth_user.systemname].length > 0) {
        firstMenuPath = menus[data.data.user.auth_user.systemname][0].path
      }

      asyncRouter = recombineRouter(menus[data.data.user.auth_user.systemname], data.data.user.auth_user.systemname, 1, [], [], false)
      reRecombineRouter()

      if (firstMenuPath) {
        asyncRouter.unshift({
          path: '/',
          redirect: '/' + firstMenuPath
        })
      }

      asyncRouter.push({ path: '/:pathMatch(.*)*', redirect: '/error/404', hidden: true })
      return { asyncRouter, firstMenuPath }

    } else if (data && data.user && data.user.auth_user && data.user.auth_user.systemname && menus[data.user.auth_user.systemname]) {
      Fan.store.state.user = data.user.auth_user
      Fan.store.state.user.avatar = Fan.store.state.user.avatar || require('@/assets/image/avatar.jpg')
      Fan.store.state.user.nickname = Fan.store.state.user.nickname || '默认昵称'
      Fan.store.state.user.entity = data.user.entity

      if (data.global_cache) {
        sessionStorage.setItem('fan-global_cache', JSON.stringify(data.global_cache))
      }

      localStorage.setItem('user-role', data.user.auth_user.systemname)

      if (menus[data.user.auth_user.systemname] && menus[data.user.auth_user.systemname].length > 0) {
        firstMenuPath = menus[data.user.auth_user.systemname][0].path
      }

      asyncRouter = recombineRouter(menus[data.user.auth_user.systemname], data.user.auth_user.systemname, 1, [], [], false)
      reRecombineRouter()

      if (firstMenuPath) {
        asyncRouter.unshift({
          path: '/',
          redirect: '/' + firstMenuPath
        })
      }

      asyncRouter.push({ path: '/:pathMatch(.*)*', redirect: '/error/404', hidden: true })
      return { asyncRouter, firstMenuPath }

    } else {
      Fan.message.warning('获取用户数据异常')
      localStorage.removeItem('token')
      localStorage.removeItem('token-session')
      localStorage.removeItem('user-role')
      return { asyncRouter: [], firstMenuPath: null }
    }
  } catch (error) {
    Fan.message.error('获取用户信息失败，请重新登录')
    localStorage.removeItem('token')
    localStorage.removeItem('token-session')
    localStorage.removeItem('user-role')
    return { asyncRouter: [], firstMenuPath: null }
  }
}

/**
 * 动态路由完成后，再循环执行一次将路由的上级关系标明
 */
function reRecombineRouter() {
  let menus = Fan.store.state.routers
  let newMenus = {}
  for (let k in menus) {
    newMenus[k] = JSON.parse(JSON.stringify(menus[k]))
    if (newMenus[k].info) {
      const type = JSON.parse(JSON.stringify(newMenus[k].info.type))
      const path = JSON.parse(JSON.stringify(newMenus[k].info.path))
      if (type==='app') {
        newMenus[k].appInfo = {}
        newMenus[k].navInfo = {}
        newMenus[k].topInfo = {}
      } else if (type==='nav') {
        newMenus[k].appInfo = Fan.store.state.routers[`/${path[0]}`].info || {}
        newMenus[k].navInfo = newMenus[k].info
        newMenus[k].topInfo = {}
      } else if (type==='menu') {
        newMenus[k].appInfo = Fan.store.state.routers[`/${path[0]}`].info || {}
        let level2Nav = Fan.store.state.routers[`/${path[0]}/${path[1]}`]
        let level3Nav = Fan.store.state.routers[`/${path[0]}/${path[1]}/${path[2]}`]
        if (level2Nav && level2Nav.info && level3Nav && level3Nav.info && level3Nav.info.type!=='nav') {
          newMenus[k].navInfo = level2Nav.info
        } else if (level3Nav && level3Nav.info) {
          newMenus[k].navInfo = level3Nav.info
        } else {
          newMenus[k].navInfo = {}
        }
        newMenus[k].topInfo = Fan.store.state.routers[`/${path.slice(0, path.length-1).join('/')}`].info || {}
      }
    }
  }
  Fan.store.state.routers = newMenus
}

/**
 * 路由递归组合（已修复404问题）
 */
function recombineRouter(menus, role, depth, topPath, topBreadcrumb, topHideChild) {
  let asyncRouter = []

  menus.forEach(({name, icon, path, template, meta, children, show, hideChild, hideBreadcrumb, showChild, hideSidebar}, k) => {
    if (template) {
      template = `${role}/${template}`
    }

    if (name && depth) {
      var type = 'menu'
      if (depth === 1) {
        type = 'app'
      } else if (depth === 2) {
        type = 'nav'
      }

      const thisPath = [...topPath, path]
      const thisBreadcrumb = [...topBreadcrumb, {
        name: name,
        icon: icon || 'appstore',
        url: `/${thisPath.join('/')}`
      }]

      hideChild = false;
      Fan.store.state.routers[`/${thisPath.join('/')}`] = {
        info: {
          name: name,
          icon: icon || 'appstore',
          level: depth,
          path: thisPath,
          url: `/${thisPath.join('/')}`,
          breadcrumb: thisBreadcrumb,
          show: show || true,
          meta: meta || {},
          type: type,
          template: template || '',  // 新增 template 字段
          hasTmp: !!template,        // 修改为布尔值
          hasChild: children ? true : false,
          hideChild: hideChild,
          showChild: showChild !== false,  // 默认显示子菜单，设为false则隐藏
          hideBreadcrumb: !!hideBreadcrumb
        }
      }

      if (type === 'app') {
        if (children && children.length > 0) {
          asyncRouter.push({
            name: `/${thisPath.join('/')}`,
            path: `/${thisPath.join('/')}`,
            component: Layout,
            meta: { hideSidebar: !!hideSidebar },
            redirect: `/${thisPath.join('/')}/${children[0].path}`,
            children: recombineRouter(children, role, depth + 1, thisPath, thisBreadcrumb, hideChild)
          })
        } else if (template) {
          asyncRouter.push({
            name: `/${thisPath.join('/')}`,
            path: `/${thisPath.join('/')}`,
            component: Layout,
            meta: { hideSidebar: !!hideSidebar },
            children: [
              { path: '', component: () => import(`../../pages/${template}`) }
            ]
          })
        }
      } else {
        if (template) {
          asyncRouter.push({
            name: `/${thisPath.join('/')}`,
            path: `/${thisPath.join('/')}`,
            meta: { hideSidebar: !!hideSidebar },
            component: () => import(`../../pages/${template}`)
          })
        } else {
          asyncRouter.push({
            name: `/${thisPath.join('/')}`,
            path: `/${thisPath.join('/')}`,
            meta: { hideSidebar: !!hideSidebar },
            redirect: `/${thisPath.join('/')}/${children[0].path}`
          })
        }

        if (children) {
          asyncRouter = [...asyncRouter, ...recombineRouter(children, role, depth + 1, thisPath, thisBreadcrumb, hideChild)]
        }
      }
    }
  })
  return asyncRouter
}
